import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="timer"
export default class extends Controller {
  connect() {
    this.time = parseInt(this.element.innerText);

    this.interval = setInterval(this.update.bind(this), 1000)
  }

  update() {
    this.time--;

    this.element.innerText = this.time;

    if (this.time == 0) this.stop();
  }

  stop() {
    clearInterval(this.interval);
  }

  disconnect() {
    this.stop()
  }
}
